// Copyright (c) 2016 Deere & Company

import MachineStatusUpdateRequests from './components/machine-status-update-requests';
import actionCreators from './action-creators';
import {connect} from 'react-redux';
import {getDateFormat} from '../../shared/services/get-date-format';
import reports from '../../routes/products/reports';

const getStateToBindToContainerProps = state => ({
    ...state.machineStatusUpdate,
    dateFormat: getDateFormat(state.user.details.settings.general.dateFormat.key),
    dealerRecommendationCount: state.dealerRecommendationsReducer.dealerRecommendations.totalElements,
    duplicatePinPlateCount: state.factoryDuplicatePinPlate.factoryDuplicatePinPlates.length,
    exportToExcel: state.exportToExcel,
    facets: {
        ...state.registrationReview.facets,
        dealerAccountsFacet: {
            ...state.registrationReview.facets.dealerAccountsFacet,
            allowedDealers: state.user.details.settings.dealer.accounts.selectedAccounts
        }
    },
    highRentalDaysCount: state.productSearch.highRentalDays.highdayscount,
    registrationReviewCount: state.registrationReview.registrations.length,
    reportsRoutes: reports(),
    searchResultsCount: state.productSearch.searchResults.length,
    security: state.user.security,
    transferApprovalsCount: state.home.wip.productTracking.transferApprovals,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(MachineStatusUpdateRequests);



// WEBPACK FOOTER //
// ./src/product/machine-status-update/state-connector.js